import React from "react";

const EtTrinityCelebrateWins = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Let user acknowledge and celebrate wins and accomplishments

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Celebrate Wins</h3>
      <p className="text-sm text-gray-600 mb-2">[Prompt to reflect on pride moments, achievements, and positive impact]</p>
      <button onClick={onClose} className="mt-4 text-sm text-blue-600 underline">Close</button>
    </div>
  );
};

export default EtTrinityCelebrateWins;